module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "noMargin"
  }, [(_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_USER') !== -1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_c('h2', [_vm._v("\n                    " + _vm._s(_vm.fncUserHeader()) + "\n                  ")])]), _vm._v(" "), (_vm.userLoading == true) ? _c('img', {
    staticStyle: {
      "margin-right": "20px",
      "margin-top": "4px"
    },
    attrs: {
      "src": require("../../shared/assets/images/ajax.gif")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userType == 'customer-users') ? _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncCreateCompany.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v("Create Company")]) : _vm._e(), _vm._v(" "), (_vm.userLoading == false) ? _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncCreateUser.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v("Create User")]) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncImportBranches.apply(null, arguments)
      }
    }
  }, [_c('v-list-tile-title', [_c('a', [_vm._v("Import Branches")])])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncImportCompanies.apply(null, arguments)
      }
    }
  }, [_c('v-list-tile-title', [_c('a', [_vm._v("Import Companies")])])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncImportUsers.apply(null, arguments)
      }
    }
  }, [_c('v-list-tile-title', [_c('a', [_vm._v("Import Users")])])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncUserSettings.apply(null, arguments)
      }
    }
  }, [_c('v-list-tile-title', [_c('a', [_vm._v("User Settings")])])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncOverrideSettings.apply(null, arguments)
      }
    }
  }, [_c('v-list-tile-title', [_c('a', [_vm._v("Doc Override Settings")])])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncExportUsers.apply(null, arguments)
      }
    }
  }, [_c('v-list-tile-title', [_c('a', [_vm._v("Export Users")])])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}